"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pricingApi = void 0;
exports.pricingApi = (http, prefix = '/pricing') => ({
    getByPropertyId(id) {
        return http.get(`${prefix}/property/${id}`);
    },
    uiGetByPropertyId(id) {
        return http.get(`${prefix}/portal/property/${id}`);
    },
    uiUpdateByPropertyId(id, pricing) {
        return http.post(`${prefix}/portal/property/${id}`, pricing);
    },
    validateForProperty(id) {
        return http.get(`/client/pricing/property/${id}/valid`);
    },
    getDefaultsByPropertyId(propertyId) {
        return http.get(`${prefix}/property/${propertyId}/defaults`);
    },
    upsertDefaultsByPropertyId(propertyId, defaults) {
        return http.put(`${prefix}/property/${propertyId}/defaults`, defaults);
    },
    deleteDefaultsByPropertyId(propertyId) {
        return http.delete(`${prefix}/property/${propertyId}/defaults`);
    },
    getTypeByPropertyId(propertyId) {
        return http.get(`${prefix}/property/${propertyId}/type`);
    },
    upsertTypeByPropertyId(propertyId, type) {
        return http.put(`${prefix}/property/${propertyId}/type`, type);
    },
    getAutomaticPricesByPropertyId(propertyId) {
        return http.get(`${prefix}/property/${propertyId}/automatic`);
    },
    getOverridesByPropertyId(propertyId) {
        return http.get(`${prefix}/property/${propertyId}/overrides`);
    },
    upsertOverrideByPropertyId(propertyId, override) {
        return http.put(`${prefix}/property/${propertyId}/overrides`, override);
    },
});
//# sourceMappingURL=index.js.map